import React from "react";
import {
  DialogContent,
  DialogContentText,
  Box,
  DialogTitle,
  Button,
  DialogActions,
  makeStyles,
  Typography,
} from "@material-ui/core";

export const ConfirmationForm = ({ closeModal }) => {
  const classes = useStyles();
  return (
    <Box width={1}>
      <DialogTitle>
        <Typography className={classes.title}>
          Thanks for signing up.
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.text}>
          You will receive an e-mail with your access link (please also check
          spam).
        </DialogContentText>
        <DialogContentText className={classes.text}>
          Enjoy working faktual and let us know what you think.
        </DialogContentText>
        <DialogContentText className={classes.text}>
          Great to have you on board!
        </DialogContentText>
        <DialogContentText className={classes.text}>
          <strong>Team faktual</strong>
        </DialogContentText>
        <DialogActions>
          <Button color="primary" onClick={closeModal}>
            Ok
          </Button>
        </DialogActions>
      </DialogContent>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  title: {
    color: "#717070",
    fontSize: "20px",
  },
  text: {
    color: "#717070",
  },
}));
